import { ERROR, INIT, LOADING, SUCCESS } from '../../constants/phase';
import produce from 'immer';
import * as api from './api';

/***********************************
 * Action Types
 ***********/
export const GET_ILLUSTRATIONS_LOADING = 'portfoplus/illustration/GET_ILLUSTRATIONS_LOADING';
export const GET_ILLUSTRATIONS_SUCCESS = 'portfoplus/illustration/GET_ILLUSTRATIONS_SUCCESS';
export const GET_ILLUSTRATIONS_ERROR = 'portfoplus/illustration/GET_ILLUSTRATIONS_ERROR';
export const RESET_ILLUSTRATIONS = 'portfoplus/illustration/RESET_ILLUSTRATIONS';

/***********************************
 * Initial State
 ***********/
const initialState = {
  list: [],
  getPhase: INIT,
  error: undefined
};

/***********************************
 * Reducer
 ***********/
export default function reducer(state = initialState, action = {}) {
  return produce(state, draft => {
    switch (action.type) {
      case GET_ILLUSTRATIONS_LOADING:
        draft.getPhase = LOADING;
        break;
      case GET_ILLUSTRATIONS_SUCCESS:
        draft.list = action.list || [];
        draft.getPhase = SUCCESS;
        draft.error = undefined;
        break;
      case GET_ILLUSTRATIONS_ERROR:
        draft.list = [];
        draft.getPhase = ERROR;
        draft.error = action.error;
        break;
      case RESET_ILLUSTRATIONS:
        return initialState;
      default:
        break;
    }
  });
}

/***********************************
 * Action Creators
 ***********/
export const getIllustrations = () => async dispatch => {
  dispatch({ type: GET_ILLUSTRATIONS_LOADING });

  try {
    const response = await api.getIllustrations();
    dispatch({
      type: GET_ILLUSTRATIONS_SUCCESS,
      list: response.results || []
    });
  } catch (error) {
    dispatch({ type: GET_ILLUSTRATIONS_ERROR, error });
  }
};
